(function() {
  angular
    .module('ocorrencias', ['aol.service', 'login.service']);
})();
